import { useEffect, useRef, useState } from 'react'

export const Tabs = ({
  items,
  value,
  onChange,
  className = '',
  isUpper = true,
}) => {
  const containerRef = useRef(null)
  const buttonsBoxRef = useRef(null)
  const [isMobile, setIsMobile] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  useEffect(() => {
    const updateMobileMenu = () => {
      const container = containerRef.current
      const buttonsBox = buttonsBoxRef.current

      if (!container || !buttonsBox) {
        return
      }

      const wasMobile = buttonsBox.classList.contains('mobile')
      const wasMenuOpen = buttonsBox.classList.contains('active')

      buttonsBox.classList.remove('mobile', 'active')
      const buttonsWidth = Array.from(buttonsBox.children).reduce(
        (width, button) => width + button.offsetWidth,
        0
      )

      buttonsBox.classList.toggle('mobile', wasMobile)
      buttonsBox.classList.toggle('active', wasMenuOpen)
      const shouldUseMobileMenu =
        container.getBoundingClientRect().width < buttonsWidth

      setIsMobile(shouldUseMobileMenu)
      if (shouldUseMobileMenu !== wasMobile) {
        setIsMenuOpen(false)
      }
    }

    updateMobileMenu()
    window.addEventListener('resize', updateMobileMenu)
    let containerWidth = containerRef.current.getBoundingClientRect().width
    const resizeObserver = new ResizeObserver(([entry]) => {
      if (entry.contentRect.width === containerWidth) {
        return
      }

      containerWidth = entry.contentRect.width
      updateMobileMenu()
    })
    resizeObserver.observe(containerRef.current)

    return () => {
      window.removeEventListener('resize', updateMobileMenu)
      resizeObserver.disconnect()
    }
  }, [items])

  const handleClick = (itemValue, isActive) => {
    if (isMobile && isActive) {
      setIsMenuOpen((isOpen) => !isOpen)
      return
    }

    setIsMenuOpen(false)
    if (onChange) {
      onChange(itemValue)
    }
  }

  return (
    <div
      className={`tabs__button tabs__button--left ${className}`.trim()}
      ref={containerRef}
    >
      <div
        className={`react ${isMobile ? 'mobile' : ''}${
          isMenuOpen ? ' active' : ''
        }`.trim()}
        role="tablist"
        ref={buttonsBoxRef}
      >
        {items.map((item) => {
          const isActive = item.value === value

          return (
            <button
              key={item.value}
              type="button"
              role="tab"
              className={`tabs__button__item ${
                isUpper ? 'uppercase' : ''
              } tabs__button__item--xsm${isActive ? ' active' : ''}`}
              aria-selected={isActive}
              onClick={() => handleClick(item.value, isActive)}
            >
              {item.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
